export const NotFound = () => {
  return (
    <div className="px-16 py-4 space-y-8">
      <h1 className="text-2xl font-bold text-darkblue_100">404 Not Found</h1>
      <p className="text-base text-darkblue_100">該当のページが見つかりませんでした</p>
    </div>
  );
};
